import gql from 'graphql-tag';
import * as Firebase from 'firebase';

const GQL = gql`
  query UploadRequest($blobKey: String!, $contentType: String!) {
    uploadRequest(blobKey: $blobKey, contentType: $contentType) {
      url
    }
  }
`;

export default async function(client: any, file: any) {
  const blobKey = file.preview.split('/').pop();
  const contentType = file.type;
  const auth = Firebase.auth();
  const token = auth && auth.currentUser ? await auth.currentUser.getIdToken() : '';
  const { data } = await client.query({
    query: GQL,
    variables: { blobKey, contentType },
    context: {
      headers: {
        authorization: token
      }
    }
  });
  const extension = contentType === 'application/vnd.google-earth.kmz' ? 'kmz' : 'kml';
  return {
    signedUrl: data.uploadRequest.url,
    filename: `${ blobKey }.${ extension }`
  };
}


// WEBPACK FOOTER //
// ./src/services/uploadRequest.ts